// slice.ts
import { AppState } from './types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: AppState = {
  messages: [
    {
      type: "bot",
      msg: "How can I help you?",
      datetime: "",
    },
  ],
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setMessages: (
      state,
      action: PayloadAction<{ type: string; msg: string; datetime: string }>
    ) => {
      state.messages.push(action.payload);
    },
    removeLastMessage:(state) => {
      state.messages.pop();
    },
  },
});

export const { setMessages, removeLastMessage } = appSlice.actions;
export default appSlice.reducer;
